import React from 'react';

const Loader = ({ size = 'md', text = '', fullScreen = false }) => {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-12 w-12',
    lg: 'h-16 w-16',
    xl: 'h-24 w-24'
  };
  
  const containerClass = fullScreen 
    ? "fixed inset-0 bg-white/80 backdrop-blur-sm flex flex-col justify-center items-center z-50"
    : "flex flex-col justify-center items-center py-8";
    
  return (
    <div className={containerClass}>
      <div className="relative">
        <div className={`animate-spin rounded-full ${sizeClasses[size]} border-4 border-gray-200`}></div>
        <div className={`animate-spin rounded-full ${sizeClasses[size]} border-4 border-primary border-t-transparent absolute top-0 left-0`}></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div className={`${size === 'sm' ? 'w-2 h-2' : size === 'lg' ? 'w-6 h-6' : size === 'xl' ? 'w-8 h-8' : 'w-4 h-4'} bg-gradient-to-r from-primary to-secondary rounded-full animate-pulse`}></div>
        </div>
      </div>
      
      {(text || fullScreen) && (
        <p className="mt-4 text-gray-600 font-medium animate-pulse text-center">
          {text || 'Loading...'}
        </p>
      )}
    </div>
  );
};

export default Loader;
